import { addDays, datePart } from "./format";

type TimedEntry = { start: string; end?: string | null; allDay: boolean };
export function agendaPeriod(event: TimedEntry, now: string): "past" | "ongoing" | "next" | "later" {
  const today = datePart(now);
  if (event.allDay) {
    const end = event.end ? datePart(event.end) : addDays(event.start, 1);
    if (end <= today) return "past";
    if (datePart(event.start) <= today) return "ongoing";
  } else {
    // Ein offenes Ende wird nicht mit einer erfundenen Dauer beendet.
    if (event.end && event.end <= now) return "past";
    if (event.start <= now) return event.end || datePart(event.start) === today ? "ongoing" : "past";
  }
  return datePart(event.start) === today ? "next" : "later";
}
